import { HTML_DATA_PARAM_FILE_PREVIEW_OPEN } from '../../../../../constants/html'

import {
  SPLIT_PANE_ESCAPE_EDITING_SELECTOR,
  SPLIT_PANE_ESCAPE_MODAL_SELECTOR,
} from './useRentalPortalListingsMultipleViewTypeList.constants'

export function isSplitPaneEscapeClaimed() {
  return (
    document.body.hasAttribute(HTML_DATA_PARAM_FILE_PREVIEW_OPEN) ||
    Boolean(document.querySelector(SPLIT_PANE_ESCAPE_MODAL_SELECTOR)) ||
    Boolean(document.activeElement?.closest(SPLIT_PANE_ESCAPE_EDITING_SELECTOR))
  )
}
